/**
 * Split black text blocks
 * into spans of their words
 * for use in styling
 *
 * @author Matt Haynes
 * @package Joi Polloi
 *
 */

const isStyleBlackBlock = () => {
    const texts = Array.from(document.querySelectorAll('.is-style-black-block'));
    if (!texts) return;

    texts.forEach(text => {
        const para = text;
        const paraSplit = para.innerHTML.split(' ');
        const newPara = paraSplit.map(word => `<span class="word">${word}</span>`).join('');

        para.innerHTML = newPara;
    });
};

export default isStyleBlackBlock;
